import { ChangeDetectionStrategy, Component, computed, Input, signal } from "@angular/core";
import { Strategy } from "@front/m19-api-client";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { StrategyEx } from "@front/m19-models";
import { TranslocoDirective } from "@jsverse/transloco";
import { fblMode, FblModeSize, IFbl } from "@front/m19-services";
import { NgClass } from "@angular/common";
import { ITooltipDirective } from "@front/m19-ui";

@Component({
  selector: "app-fbl-mode",
  imports: [ITooltipDirective, TranslocoDirective, NgClass],
  templateUrl: "./fbl-mode.component.html",
  styleUrls: ["./fbl-mode.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FblModeComponent implements ICellRendererAngularComp {
  _strategy = signal<StrategyEx | undefined>(undefined);
  constraint = computed<IFbl | undefined>(() =>
    this._strategy() ? fblMode[this._strategy()!.constraint!] : undefined,
  );
  isWarning = computed(() => this.constraint()?.isWarning);

  @Input({ required: true }) set strategy(strategy: Strategy) {
    this._strategy.set(strategy as StrategyEx);
  }

  _size = signal<FblModeSize>(FblModeSize.small);

  @Input() set size(size: FblModeSize) {
    this._size.set(size);
  }

  agInit(params: ICellRendererParams & { strategy: StrategyEx; size: FblModeSize }): void {
    this.strategy = params.strategy;
    this.size = params.size;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  protected readonly FblModeSize = FblModeSize;
}
